import { getFacilityLiveQuery } from '../models/facility'; 

import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';

import { useLiveQuery } from 'dexie-react-hooks';

export default function CheckFacilityConfiguration() {
    const navigate = useNavigate();
    const facility = useLiveQuery(getFacilityLiveQuery);
    const validationMessages = [];

    console.log("dexie facility", facility);

    if (facility) {

        if (!!facility?.poc_name === false) {
            validationMessages.push("Point of contact is not set");
        }

        const timeframes = facility?.workday_timeframes || [];
        const hasTimeframes = Array.isArray(timeframes) && timeframes.length > 0;
        const hasLegacyTimes = !!facility?.start_of_day && !!facility?.end_of_day;

        if (!hasTimeframes && !hasLegacyTimes) {
            validationMessages.push("Workday timeframes are not set");
        }

        if (hasTimeframes) {
            const hasIncomplete = timeframes.some((cur)=>!cur?.start_of_day || !cur?.end_of_day);
            if (hasIncomplete) {
                validationMessages.push("One or more workday timeframes are incomplete");
            }
        }

        console.log(validationMessages);
    }

    return (
        <>
        {facility && validationMessages.length > 0 && 
            <Alert 
                severity="warning"
                action={
                    <Button variant="contained" onClick={()=>{
                        navigate("/institution/details");
                    }}>
                        Configure
                    </Button>
                }
            >
                <div>Your facility is not configured yet:</div>
                {validationMessages.map((cur)=>{
                    return (
                        <div>{cur}</div>
                    );
                })}
            </Alert>
        }
        </>
    )
}
